/* eslint-disable eqeqeq */
import React, { useState } from "react";
import {
  API,
  cddCustomerTypeOptions,
  cddOptions,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { formatName } from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import MainBody from "../../../components/MainBody/MainBody";
import { Button } from "../../../components/ui/button";
import {
  LucideMessageSquareShare,
  Verified,
  XOctagon,
} from "lucide-react";
import Confirmation from "../../../components/Confirmation";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { PhoneInput } from "../../../components/ui/phone-input";
import { Checkbox } from "../../../components/ui/checkbox";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import EscalatedModal from "./EscalatedModal";

// * Start: Vendor Listing Page
const ExpandContactTypeCDD = ({ cddsList, fetchCDDs }) => {
  // * Start: Url Management State

  const [loading, setLoading] = useState(false);

  // * End: Url Management State

  // * Start: List Management State

  const [confirmVerify, setConfirmVerify] = useState(false);
  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  const [mobile, setMobile] = useState();
  const [consent, setConsent] = useState();
  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  const [confirmEscalated, setConfirmEscalated] = useState(false);

  // * End: List Management State

  //* End: Fetch Vendor List Form The API

  const toggleConfirmVerify = (id, data) => {
    if (confirmVerify) {
      setCddId();
      setCddItem();
      setMobile();
      setConsent();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmVerify(!confirmVerify);
  };

  const toggleConfirmEscalated = (id, data) => {
    if (confirmEscalated) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmEscalated(!confirmEscalated);
  };

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  const handleVerifyID = async () => {
    try {
      setLoading(true);
      await get(`${API.GET_CDD_VERFIY}/${cddId}?mobile=${mobile}`);
      setLoading(false);
      fetchCDDs();
    } catch (error) {
      setLoading(false);
      fetchCDDs();
    }
  };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of EnhancedCDDs)
   * @returns {Array} Vendor List
   **/

  const cddsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: cddsList[i]?.id,
        id: cddsList[i]?.id ? cddsList[i]?.id : "",
        cdd: cddsList[i]?.cdd
          ? cddOptions?.find((item) => item.value === cddsList[i]?.cdd)?.label
          : "-",
        cdd_customer_type: cddsList[i]?.cdd_customer_type
          ? cddCustomerTypeOptions?.find(
              (item) => item.value === cddsList[i]?.cdd_customer_type,
            )?.label
          : "-",
        risk: (
          <div className="flex items-center gap-2">
            {cddsList[i]?.risk
              ? riskProfile?.find((item) => item.value == cddsList[i]?.risk)
                  ?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(cddsList[i]?.id, cddsList[i]);
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: cddsList[i]?.source ? cddsList[i]?.source : "",

        verification_document_type: cddsList[i]?.verifications[i]
          ?.verification_document_type?.label
          ? cddsList[i]?.verifications[i]?.verification_document_type?.label
          : "",
        date_verified: cddsList[i]?.verifications[i]?.date_verified
          ? cddsList[i]?.verifications[i]?.date_verified
          : "",
        verified_by: cddsList[i]?.verifications[i]?.verified_by
          ? formatName(
              cddsList[i]?.verifications[i]?.verified_by?.first_name,
              cddsList[i]?.verifications[i]?.verified_by?.last_name,
            )
          : "",
        method: cddsList[i]?.verifications[i]?.method_title
          ? cddsList[i]?.verifications[i]?.method_title
          : "",
        bureau:
          cddsList[i]?.bureau === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              Bureau
            </div>
          ) : cddsList[i]?.bureau === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              Bureau
            </div>
          ) : (
            ""
          ),
        dvs:
          cddsList[i]?.dvs === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              DVS
            </div>
          ) : cddsList[i]?.dvs === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              DVS
            </div>
          ) : (
            ""
          ),
        pep:
          cddsList[i]?.pep === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              PEP
            </div>
          ) : cddsList[i]?.pep === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              PEP
            </div>
          ) : (
            ""
          ),
        sanction:
          cddsList[i]?.sanction === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              Sanction
            </div>
          ) : cddsList[i]?.sanction === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              Sanction
            </div>
          ) : (
            ""
          ),
        action: (
          <>
            {cddsList[i]?.source !== "Visual" ? (
              // cddsList[i]?.status !== 1 &&
              cddsList[i]?.cdd === "1" ? (
                // <Button
                //   onClick={() => {
                //     toggleConfirmEscalated(cddsList[i]?.id, cddsList[i]);
                //   }}
                // >
                //   <div className="flex items-center gap-1">
                <CustomTooltip message={"Escalate"}>
                  <span>
                    <LucideMessageSquareShare
                      size={18}
                      onClick={() => {
                        toggleConfirmEscalated(cddsList[i]?.id, cddsList[i]);
                      }}
                    />
                  </span>
                </CustomTooltip>
              ) : (
                //     <span>Escalated</span>
                //   </div>
                // </Button>
                <Button
                  onClick={() => {
                    toggleConfirmVerify(cddsList[i]?.id, cddsList[i]);
                  }}
                >
                  <div className="flex items-center gap-1">
                    <Verified size={18} />
                    <span>Verify</span>
                  </div>
                </Button>
              )
            ) : (
              <span className="flex items-center gap-2 justify-center">
                {cddsList[i]?.cdd === "1" && (
                  <>
                    {/* <Button
                      onClick={() => {
                        toggleConfirmEscalated(cddsList[i]?.id, cddsList[i]);
                      }}
                    >
                      <div className="flex items-center gap-1"> */}
                    <CustomTooltip message={"Escalate"}>
                      <span>
                        <LucideMessageSquareShare
                          size={18}
                          onClick={() => {
                            toggleConfirmEscalated(
                              cddsList[i]?.id,
                              cddsList[i],
                            );
                          }}
                        />
                      </span>
                    </CustomTooltip>
                    {/* <span>Escalated</span>
                      </div>
                    </Button> */}
                    <span>/</span>
                  </>
                )}
                <CustomTooltip message={"Edit"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEdit}
                      size="1x"
                      onClick={() => {
                        toggleVisual(cddsList[i]?.id, cddsList[i]);
                      }}
                    />
                  </span>
                </CustomTooltip>
              </span>
            )}
          </>
        ),
      });
    }
    return items;
  };

  const CDDs = cddsGenerator(cddsList?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "verification_document_type",
      text: "Document Type",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "date_verified",
      text: "Date Verified",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "verified_by",
      text: "Verified By",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "method",
      text: "Method",
    },
    {
      dataField: "risk",
      text: "Risk Profile",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "source",
      text: "Source",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "bureau",
      text: "Bureau",
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "pep",
      text: "PEP",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "sanction",
      text: "Sanction",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  //* End: Vendor List Columns

  //* End: Vendor List Sorting

  //* End: Vendor List and URL Mangement useEffect

  return (
    <MainBody
      search={false}
      actionContent={<></>}
      loading={loading}
      expandList={true}
      innerBody={true}
      parentHeight={true}
      // mainClassName="w-[calc(100%-3rem)]"
    >
      {/* Vendor Table and Pagination */}
      <div className="custom-table">
        <div className="table-body-class">
          <BootstrapTable
            keyField="id"
            remote
            data={CDDs}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>

        <Confirmation
          title={"Verify Data"}
          open={confirmVerify}
          setOpen={setConfirmVerify}
          toggleShow={() => {
            toggleConfirmVerify();
          }}
          className="sm:max-w-1/2"
          message={
            <>
              <div>Are you sure you want to verify the record?</div>
              <div className="grid grid-cols-1 text-left mt-2">
                <div className="grid gap-2">
                  <Label htmlFor="phone">
                    <CustomLabelText
                      required={cddItem?.method === 2 ? true : false}
                      labelText="Mobile No."
                      errorField={""}
                    />
                  </Label>
                  <PhoneInput
                    onChange={(e) => {
                      setMobile(e);
                    }}
                    value={mobile}
                    defaultValue={"+61"}
                    defaultCountry={"AU"}
                    minLength={15}
                    maxLength={15}
                  />
                </div>
                <div className="flex items-start space-x-2 mt-4">
                  <Checkbox
                    id="terms"
                    checked={consent}
                    name="same_address"
                    onClick={() => {
                      setConsent(!consent);
                    }}
                  />
                  <label
                    htmlFor="terms"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-justify"
                  >
                    I confirm that I am authorised to provide the personal
                    details presented and I consent to my information being
                    checked with the document issuer or official record holder
                    via third party systems for the purpose of confirming my
                    identity.
                  </label>
                </div>
              </div>
            </>
          }
          disabled={cddItem?.method === 2 ? !mobile && !consent : !consent}
          okAction={async () => {
            handleVerifyID();
            toggleConfirmVerify();
          }}
          cancelAction={() => {
            toggleConfirmVerify();
          }}
        />

        {showVisual && (
          <ResponsiveDrawerForm
            description={""}
            title={`Visual Changes`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleVisual();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showVisual}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setShowVisual}
          >
            <VerifyModal
              data={cddItem?.verifications[0]}
              toggleVisual={toggleVisual}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {showRisk && (
          <ResponsiveDrawerForm
            description={""}
            title={`Risk Change`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleRisk();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showRisk}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setShowRisk}
          >
            <RiskChange
              data={cddItem}
              toggleRisk={toggleRisk}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {confirmEscalated && (
          <ResponsiveDrawerForm
            description={""}
            title={`Escalated`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleConfirmEscalated();
            }}
            write={true}
            buttonText={""}
            open={confirmEscalated}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setConfirmEscalated}
            className={"sm:max-w-3xl"}
          >
            <EscalatedModal
              data={cddItem}
              toggleConfirmEscalated={toggleConfirmEscalated}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}
      </div>
    </MainBody>
  );
};

export default ExpandContactTypeCDD;
// * End: Vendor Listing Page
